import React from 'react'

import Auth from '../components/auth'

export default () => {
  return <Auth newUser />
}
